import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { IonInput } from '@ionic/angular';
import { round } from 'lodash-es';

import { BaseEntity } from '../models/base-entity';
import { UnitFamily } from '../models/enums/unit-families';

@Injectable({
  providedIn: 'root'
})
export class Utilities {

  static storageGetItem(key: string) {
    return Preferences.get({ key }).then(res => safeJSONParse(res?.value));
  }
  static storageSetItem(key: string, value: any) {
    if (value != null) {
      value = safeJSONStringify(value);
    }
    return Preferences.set({ key, value });
  }
  static storageRemoveItem(key: string) {
    return Preferences.remove({ key });
  }

  // IonFocus Output
  ionFocusInputSelect(target: any) {
    target?.getInputElement().then((input: any) => {
      input?.select();
    });
  }

  comparisonFunc(value: any, option: any): boolean {
    if (value === null && !option) { // HACK null comes in as '' for some reason with ion-select
      return true;
    }
    return value === option;
  }

  objectComparisonFunction(value: any, option: any): boolean {
    if (value === null && !option) { // HACK null comes in as '' for some reason with ion-select
      return true;
    }
    return (option && option.id) === (value && value.id);
  }

  sortCompare(a: number | string, b: number | string, isAsc: boolean = false) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
   *
   * @param index
   * @param entity - BaseEntity, but to work with orderBy has to be any
   * @returns
   */
  trackByBaseEntity(index: number, entity: BaseEntity | any) {
    return entity?.id || index;
  }

}

export const safeJSONParse = (value: any) => {
  try {
    return JSON.parse(value);
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const safeJSONStringify = (value: any) => {
  try {
    return JSON.stringify(value);
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const trueRound = (value: number, precision: number = 3) => {
  if (value == null) { return null; }
  return round(value, precision);
};

export const convertLengthToAcres = (length: number, unit: UnitFamily): number => {
  if (length == null || isNaN(length)) return null;
  let value;
  if (UnitFamily.Metric === unit) {
    value = length / 4047;
  } else {
    value = length / 43560;
  }
  return trueRound(value, 2);
};

